import { render, staticRenderFns } from "./ShippingRateListItem.vue?vue&type=template&id=f4fce16a&scoped=true&"
import script from "./ShippingRateListItem.vue?vue&type=script&lang=js&"
export * from "./ShippingRateListItem.vue?vue&type=script&lang=js&"
import style0 from "./ShippingRateListItem.vue?vue&type=style&index=0&id=f4fce16a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fce16a",
  null
  
)

export default component.exports